import VermietungBuchenBase from '../../../pages/VermietungBuchen';
export default VermietungBuchenBase;
